import React from 'react';
import { findDomNode } from 'react-dom';
import ajax from 'superagent';
import { fetchEnd, fetchError, fetchStart } from 'redux/actions';
import { parseJSON } from './common';
import { requestUrl } from './utils/url';
import { wrap } from './utils/promise';

export let RequestConfig = {

}

let currentFeature = null;

export function Request(p,dispatch) { //url,data,timeout,type,event:{dataFilter,before,success,complete,error}
  initRequest(p);
  if (!p.type) p.type = "POST";
  if (p.before) p.before(p,dispatch);

  let headers = p.headers || {};
  if (!headers['Content-Type']) {
    if (!p.blob) //blob不要设置content-type ，superagent框架会自动设置
      headers['Content-Type'] = 'application/json';

    if (p.blob) {
      headers['directoryId'] = p.directoryId;
      if (p.size) //如果指定了文件大小，那么发送到服务器，以便效验
        headers['fileSize'] = p.size;
    }
  }
  
  let body = p.body ? p.body :(p.blob ? (p.data || null) : (p.data ? JSON.stringify(p.data) : null));

  let feature = p.type === "POST" ? ajax.post(p.url) : ajax.get(p.url);

  currentFeature = feature;
  //feature.withCredentials(); //可以激活发送原始cookie的能力，不过只有在Access-Control-Allow-Origin不是一个通配符(*)，并且Access-Control-Allow-Credentials为’true’的情况下才行
  feature.set(headers);
  if (p.blob) {
    feature.timeout({
      response: 600000000,  // Wait 1000 seconds for the server to start sending,
      deadline: 600000000, // but allow 3000 seconds for the file to finish loading.
    }).on('progress', e => {
      if (p.progress) p.progress(e);
    })
    feature.field("file", body);
  }
  else {
    feature.timeout({
      response: p.timeout || 60000,  // Wait 10 seconds for the server to start sending,
      deadline: p.timeout || 60000, // but allow 30 seconds for the file to finish loading.
    });
    feature.send(body);
  }

  if (p.await) {
    return new Promise((resolve, reject) => {
      feature.then((response) => {
        processResponse(response);
        currentFeature = null;
        let result = parseJSON(response.text);

        if (p.dataFilter)
          result = p.dataFilter(result);
          
        resolve(result);
      }, (e) => {
        // currentFeature = null;
        // let error = getErrorMessage(e);
        // reject(error);
        currentFeature = null;
        let msg = getErrorMessage(e);
        reject(new Error(msg)); //要统一成抛出的异常都是ex
      });
    });
  }

  const processError = (e,dispatch) => {
    if (p.complete)
      p.complete(dispatch);
    if (p.error)
      p.error(e,dispatch);
  }

  return feature.then(response => {
    processResponse(response);
    currentFeature = null;
    if (p.complete)
      p.complete(dispatch);

    let result = parseJSON(response.text);

    if (p.dataFilter)
      result = p.dataFilter(result);

    if (p.success)
      p.success(result);
  }, e => {
    currentFeature = null;
    processError(e,dispatch);
  });

}

Request.mute = (arg,dispatch) => {
  return Request({ //静默调用
    before: () => {
    },
    success: (r) => {
    },
    complete: () => {
    },
    error: (msg) => {
      if(dispatch)
        dispatch(fetchError(msg));
    },
    ...arg
  },dispatch);
}

let _requestEvents = {};

Request.on = (name, func) => {
  let l = _requestEvents[name];
  if (!l) l = _requestEvents[name] = [];
  l.push(func);
}


function processResponse(response) {
  let l = _requestEvents["process"];//process是处理请求的最开始的事件
  if (l) {
    l.forEach((func) => {
      func(response);
    });
  }
}

Request.call = function (p) {
  return Request({
    ...p,
    await: true
  });
}

Request.abort = function () {
  if (currentFeature) {
    currentFeature.abort(); //取消后，文件已传部分还是会被保存，所以需要指定fileSie头，让服务端删除冗余文件
    currentFeature = null;
    return true;
  }
  return false;
}


function initRequest(p) {
  if (RequestConfig.init) {
    RequestConfig.init(p);
  }
  if (!p.url.startsWith("http:") && !p.url.startsWith("https:")) {
    p.url = `${requestUrl(RequestConfig.domain)}/${p.url}`;
  }

  if (p.await) return;
  if (!p.before) p.before = RequestConfig.before;
  if (!p.complete) p.complete = RequestConfig.complete;
  if (!p.error) {
    p.error = function (e,dispatch) {
      let msg = getErrorMessage(e, p.url);
      if (RequestErrorIoc(msg, p,dispatch) === false) return; //如果依赖注入拦截了错误，那么后续不再处理
      RequestConfig.error(msg,dispatch);
    };
  } else {
    let _error = p.error;
    p.error = function (e,dispatch) {
      let msg = getErrorMessage(e, p.url);
      if (RequestErrorIoc(msg, p,dispatch) === false) return; //如果依赖注入拦截了错误，那么后续不再处理
      _error(msg,dispatch);
    };
  }
}

function RequestErrorIoc(msg, p,dispatch) {
  let ioc = RequestConfig.ioc;
  if (!ioc || !ioc.error) return;
  return ioc.error(msg, p,dispatch);
}


function getErrorMessage(e, url) {
  if (e.response && e.response.text) return e.response.text;  //ff这样获取错误
  let msg = e.message;
  if ((msg.indexOf(" timeout ") > -1) || (msg.indexOf("Timeout ") > -1)) msg = `${url || ''}请求超时`;
  if (msg.indexOf("Abort") > -1) msg = "请求已取消";
  return msg;
}


export function Upload(p,dispatch) {
  let args = p.data || {};
  if (args.file) {
    p.data = args.file;
    p.size = args.file.size;
  }
  else {
    p.data = args.blob;
    //formData.append("file", args.blob, args.fileName);
  }

  p.blob = true;
  p.url = RequestConfig.uploadUrl;
  p.directoryId = args.directoryId;
  return Request(p,dispatch);
}


//以后就用该方法
export function request(arg,dispatch){
  if(!dispatch) return Request.mute({...arg,await:true});
  return wrap((resolve, reject) => {
    Request({
      before: () => {
        dispatch(fetchStart());
      },
      success: (r) => {
        resolve(r);
        dispatch(fetchEnd());
      },
      complete: () => {
        dispatch(fetchEnd());
      },
      error: (msg) => {
        // reject(new Error(msg));
        dispatch(fetchError(msg));
      },
      ...arg,
    });
  });  
}